import { notification } from "antd";
import { useState, useEffect, useCallback } from "react";
import { getQuery, getRetailerQueryPart } from "../helper";
import { IFetchAvailableOrders, IUseAvailableOrders } from "../../../types/CloudFleetRouting";

const useAvailableOrders: IUseAvailableOrders = (props) => {
  const { 
    getAvailableOrdersJobsMap, 
    fetchRestrictedListAdminRetailers, 
    clearCFRStateJobsMap,
    orders  // ← ADD: Get orders from props
  } = props;
  
  const [isOrdersLoading, setOrdersLoading] = useState<boolean>(false);
  const [filteredOrders, setFilteredOrders] = useState<any[]>([]);
 // ← NEW: State for filtered orders

  // ← NEW: Filter postponed orders by date
const filterPostponedOrdersByDate = useCallback((allOrders: any[]) => {
  if (!allOrders || allOrders.length === 0) {
    return [];
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  console.log('=== FILTERING ORDERS ===');
  console.log('Today date:', today);
  console.log('Total orders:', allOrders.length);

  const filtered = allOrders.filter(order => {
    console.log(`\nOrder ${order.id}:`);
    console.log('- Status:', order.status);
    console.log('- PostponedTime:', order.postponedTime);

    // Show all 'new' orders
    if (order.status === 'new') {
      console.log('- Result: SHOW (new order)');
      return true;
    }

    // For postponed orders, check the date
    if (order.status === 'postponed' || order.status === 'postponed_after_pickup') {
      // Show if no postponed date
      if (!order.postponedTime || order.postponedTime === '') {
        console.log('- Result: SHOW (no postponed date)');
        return true;
      }

    // Parse DD/MM/YYYY format OR DD.MM.YYYY format OR ISO format
try {
  let postponedDate;
  
  // Check if it's ISO format (with T)
  if (order.postponedTime.includes('T')) {
    postponedDate = new Date(order.postponedTime);
  } 
  // Check if it's DD.MM.YYYY format (with dots)
  else if (order.postponedTime.includes('.')) {
    const [day, month, year] = order.postponedTime.split('.');
    postponedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
  // Otherwise it's DD/MM/YYYY format (with slashes)
  else {
    const [day, month, year] = order.postponedTime.split('/');
    postponedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
  
  postponedDate.setHours(0, 0, 0, 0);

  console.log('- Parsed date:', postponedDate);
  console.log('- Comparison: postponedDate <= today?', postponedDate <= today);

  const shouldShow = postponedDate <= today;
  console.log('- Result:', shouldShow ? 'SHOW' : 'HIDE');
  return shouldShow;
} catch (e) {
  console.error('Error parsing date:', order.postponedTime, e);
  return false;
}
    }

    // Show all other statuses
    console.log('- Result: SHOW (other status)');
    return true;
  });

  console.log('\n=== FILTERING RESULTS ===');
  console.log('Filtered orders count:', filtered.length);
  console.log('Filtered orders:', filtered);

  return filtered;
}, []);

  // ← NEW: Apply filtering whenever orders change
  useEffect(() => {
    const filtered = filterPostponedOrdersByDate(orders);
    setFilteredOrders(filtered);
  }, [orders, filterPostponedOrdersByDate]);

  const fetchAvailabeOrders = async ({ selectedRetailer, searchedAddress }: IFetchAvailableOrders) => {
    setOrdersLoading(true);
    try {
      const restrictedQuery = getRetailerQueryPart(selectedRetailer);
      const addressQuery = getQuery(searchedAddress, "address");
      await getAvailableOrdersJobsMap({}, { query: { ...restrictedQuery, ...addressQuery } });
    } catch (error) {
      notification.error({ message: "Opps! Unable to fetch restricted available orders" });
    } finally {
      setOrdersLoading(false);
    }
  };

  const fetchRestrictedRetailer = async () => {
    try {
      await fetchRestrictedListAdminRetailers();
    } catch (error) {
      notification.error({ message: "Opps! Unable to fetch restricted retailers" });
    }
  };

  const clearCFRState = async () => {
    try {
      await clearCFRStateJobsMap();
    } catch (error) {
      notification.error({ message: "Opps! Unable to clear CFR state" });
    }
  };

  return {
    isOrdersLoading,
    fetchAvailabeOrders,
    fetchRestrictedRetailer,
    clearCFRState,
    filteredOrders,  // ← NEW: Return filtered orders
  };
};

export default useAvailableOrders;